import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../data/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('preferredLanguage') || 'en';
  });

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  // t('nav.products') → looks up translations.nav.products[language]
  const t = useCallback((key, fallback) => {
    const keys = key.split('.');
    let val = translations;
    for (const k of keys) {
      val = val?.[k];
      if (!val) return fallback || key;
    }
    return val[language] || val['en'] || fallback || key;
  }, [language]);

  // tx({ en: 'Hello', fr: 'Bonjour' }) → resolves bilingual mock data values
  const tx = useCallback((val) => {
    if (val && typeof val === 'object' && !Array.isArray(val) && 'en' in val) {
      return val[language] || val.en;
    }
    return val;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t, tx }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
